// module factories are used so entry inlining is disabled
// startup
// Load entry module and return exports
__webpack_require__("l8aYy");
__webpack_require__("WvSPy");
__webpack_require__("Bva7h");
var __webpack_exports__ = __webpack_require__("kIL25");
